module.exports = __webpack_public_path__ + "img/aboutUs-mxm.50476155.png";